import { RG_TYPE, getRgObjectsOfType, GetAllMuscles, GetAllJoints } from "@project-rouge/rg-core";
import { queryPivot, addOpeningOnClosestPoint, applyInverseTransform } from "@project-rouge/rg-three";
import { Vector3, Line3 } from "three";
const needsOpeningType = [RG_TYPE.Apartment, RG_TYPE.Entrance, RG_TYPE.TechnicalSpace, RG_TYPE.Core];
const pivot = [0.5, 0, 0.5];
const _buildingDoorPos = new Vector3();
const _projectionPoint = new Vector3();
const _lines = [new Line3(), new Line3()];
function addEntranceOpeningsToCorridors(building) {
  const needsOpening = [];
  const corridors = [];
  for (const child of building.children) {
    if (child.type === RG_TYPE.Corridor)
      corridors.push(child);
    else if (needsOpeningType.includes(child.type))
      needsOpening.push(child);
  }
  const muscleToTendon = getMuscleToTendonMap(building);
  const jointToTendons = getJointToTendonsMap(building);
  const tendonToCorridor = new Map(corridors.map((c) => [c.data.levelId + c.data.tendonID, c]));
  for (const obj of needsOpening) {
    const doors = getRgObjectsOfType(obj, RG_TYPE.Door).filter((d) => !!d.data.isEntrance);
    if (doors.length === 0)
      return;
    if (obj.data.muscleID) {
      addOpeningBasedOnMuscle({ obj, tendonToCorridor, muscleToTendon, door: doors[0] });
    } else if (obj.type === RG_TYPE.Core && obj.data.jointID) {
      addOpeningBasedOnJoint({ obj, tendonToCorridor, jointToTendons, doors });
    }
  }
}
function getMuscleToTendonMap(building) {
  return new Map(
    GetAllMuscles(building.data.anatomy).map((m) => [m.id, m.bone.tendon])
  );
}
function getJointToTendonsMap(building) {
  return new Map(
    GetAllJoints(building.data.anatomy).map((j) => [j.id, j.bones.map((b) => b.tendon)])
  );
}
function addOpeningBasedOnMuscle({ door, tendonToCorridor, muscleToTendon, obj }) {
  const buildingDoorPos = queryPivot({ obj, pivot, out: _buildingDoorPos, type: RG_TYPE.Door, query: (d) => d === door });
  const tendon = muscleToTendon.get(obj.data.muscleID);
  const corridor = tendonToCorridor.get(obj.data.levelId + tendon.id);
  addOpeningOnClosestPoint({
    obj: corridor,
    type: RG_TYPE.Opening,
    size: door.size,
    point: applyInverseTransform(buildingDoorPos.toArray(), corridor)
  });
}
function addOpeningBasedOnJoint({ doors, tendonToCorridor, jointToTendons, obj }) {
  const tendons = jointToTendons.get(obj.data.jointID);
  const tendonLines = tendons.map((t, i) => tendonToLine(t, _lines[i]));
  for (const door of doors) {
    const buildingDoorPos = queryPivot({ obj, pivot, out: _buildingDoorPos, type: RG_TYPE.Door, query: (d) => d === door });
    const i = closestLineToPoint(tendonLines, buildingDoorPos);
    const corridor = tendonToCorridor.get(obj.data.levelId + tendons[i].id);
    addOpeningOnClosestPoint({
      obj: corridor,
      type: RG_TYPE.Opening,
      size: door.size,
      point: applyInverseTransform(buildingDoorPos.toArray(), corridor)
    });
  }
}
function tendonToLine(tendon, out) {
  out.start.fromArray(tendon.points[0]);
  out.end.fromArray(tendon.points[1]);
  return out;
}
function closestLineToPoint(lines, point) {
  if (lines.length === 1)
    return 0;
  const dist0 = lines[0].closestPointToPoint(point, false, _projectionPoint).distanceToSquared(point);
  const dist1 = lines[1].closestPointToPoint(point, false, _projectionPoint).distanceToSquared(point);
  return dist0 < dist1 ? 0 : 1;
}
export {
  addEntranceOpeningsToCorridors
};
//# sourceMappingURL=index28.js.map
